/**
 * WelcomeHeader
 * Displays patient first name on the validation page.
 * Shown after /survey/verify-token succeeds.
 */
export default function WelcomeHeader({ firstName }) {
    if (!firstName) return null;

    return (
        <div className="mb-4">
            <h1 className="text-xl font-bold mb-1" style={{ color: '#1B2F7E' }}>
                Welcome, {firstName}
            </h1>
            <p className="text-sm leading-relaxed" style={{ color: '#4a6882' }}>
                To ensure privacy, please enter your date of birth.
            </p>
        </div>
    );
}
